interface InfoItemProps {
  label: string;
  value?: string | number | null;
  placeholder?: string;
  className?: string;
  labelClassName?: string;
  valueClassName?: string;
}

export default function InfoItem({
  label,
  value,
  placeholder = "Não informado",
  className = "",
  labelClassName = "",
  valueClassName = ""
}: InfoItemProps) {
  return (
    <div className={`space-y-1 ${className}`}>
      <p className={`text-base text-gray-800 font-semibold ${labelClassName}`}>
        {label}
      </p>
      <p className={`text-sm font-medium text-gray-500 ${valueClassName}`}>
        {value || <span className="text-gray-400">{placeholder}</span>}
      </p>
    </div>
  );
}